<template>
  <div>
    <Loading v-if="loading" />

    <div v-else>
      <Title small> Mais Recentes </Title>

      <v-row class="my-0" v-if="items.length">
        <v-col
          class="py-0"
          cols="12"
          sm="6"
          lg="12"
          v-for="({ img, title, date, to }, keyItems) in items"
          :key="keyItems"
        >
          <v-card class="mt-6 item" :to="to" flat>
            <v-row class="my-0">
              <v-col cols="5" class="py-0">
                <img
                  v-if="img"
                  :src="files + img"
                  :alt="title"
                  class="d-block item-img"
                />
              </v-col>
              <v-col cols="7" class="pl-0 py-2">
                <div
                  class="
                    text-caption text-md-h6
                    grey--text
                    text--darken-4
                    font-weight-bold
                  "
                >
                  <div class="item-title">
                    {{ title }}
                  </div>
                </div>

                <div v-if="date" class="grey--text text--darken-1 d-flex mt-2">
                  <v-icon size="16" class="align-baseline">
                    far fa-calendar
                  </v-icon>

                  <div class="text-caption ml-2">
                    {{ formatDate(date) }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col v-if="items.length == 6" class="text-right mt-4" cols="12">
          <v-btn color="primary" depressed :to="path"> Veja Mais </v-btn>
        </v-col>
      </v-row>

      <v-alert v-else class="mt-6" type="info">
        Nenhum item encontrado.
      </v-alert>
    </div>
  </div>
</template>

<script>
import Loading from "../widgets/Loading.vue";
import Title from "../widgets/Title.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  path: "/imprensa/noticias",
  mod: "articles",
};

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
  }),
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "medium" })
        .format(new Date(date.replace(" ", "T")))
        .replaceAll(" de", "")
        .replaceAll(".", "");
    },
    get() {
      const params = {
        itemsPerPage: 7,
      };

      this.loading = true;

      var i = false;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, data) => {
            const items = [];
            data.map(({ id, img, title, date }, index) => {
              if (id == this.itemId) i = true;

              if ((id != this.itemId && i && index <= 6) || (!i && index <= 5))
                items.push({
                  img,
                  title,
                  date,
                  to: `${this.path}/${formatToURL(title)}-${id}`,
                });
            });
            this.items = items;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 16 / 12;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
